// The pages a visitor sees before or outside sign-in, and the download page (OQ-162).
export const svAuth = {
  logoAlt: 'Logotyp',
  login: {
    title: 'Logga in | The Frozen Eye',
    email: 'E-post',
    emailIncorrect: 'E-postadressen är fel',
    password: 'Lösenord',
    passwordIncorrect: 'Lösenordet är fel',
    submit: 'Logga in',
    forgotPassword: 'Glömt lösenordet?'
  },
  forgotPassword: {
    title: 'Glömt lösenordet | The Frozen Eye',
    sent: 'Vi har skickat ett e-postmeddelande med en länk för att återställa lösenordet.',
    submit: 'Skicka länk för att återställa lösenordet',
    backToLogin: 'Tillbaka till inloggningen'
  },
  signup: {
    invalidLink: 'Registreringslänken är ogiltig.',
    signingUpWith: 'Du registrerar dig med <b>{{email}}</b>',
    displayName: 'Visningsnamn',
    displayNameMissing: 'Ange ett visningsnamn',
    failed: 'Registreringen misslyckades. Länken kan ha gått ut – be om en ny inbjudan.',
    submit: 'Registrera'
  },
  newPassword: {
    invalidLink: 'Återställningslänken är ogiltig.',
    enterFor: 'Ange ett nytt lösenord för <b>{{email}}</b>',
    password: 'Nytt lösenord',
    failed: 'Kunde inte spara lösenordet. Länken kan ha gått ut – be om en ny.',
    submit: 'Spara'
  },
  camera: {
    photo: 'Bild',
    video: 'Video',
    loading: 'Laddar kameran',
    loadingSlow: '(Om det tar lång tid kan du ladda om sidan)',
    grantCamera: 'Du måste ge tillgång till kameran.',
    info: {
      title: 'Info och hjälp',
      enableVideoTitle: 'Slå på video',
      enableVideoText:
        'Du har stängt av video. Vill du slå på det igen trycker du på knappen nedan. Se först till att ingen annan app använder mikrofonen.',
      microphoneTitle: 'Problem med mikrofonen',
      microphoneText:
        'Fungerar inte appen? Det kan bero på att mikrofonen inte är tillgänglig eller används av en annan app.',
      disableVideoText: 'Du kan få appen att fungera genom att stänga av video med knappen nedan.',
      enableVideo: 'Slå på video',
      disableVideo: 'Stäng av video',
      permissionsTitle: 'Ge behörigheter',
      permissionsText:
        "Fungerar appen fortfarande inte behöver vi tillgång till kameran, mikrofonen och din position. Med video påslaget fungerar appen bättre. Tryck på 'Tillåt' när webbläsaren frågar.",
      privacy:
        'Vi värnar om din integritet och använder bara uppgifterna till det appen är avsedd för.<br/><policy>Läs vår integritetspolicy här.</policy>',
      guide:
        'Fungerar appen fortfarande inte, eller har du råkat neka tillgång eller behörigheter? <guide>Läs vår guide</guide>'
    },
    takePhoto: 'Ta bild',
    startRecording: 'Starta inspelning',
    stopRecording: 'Stoppa inspelning'
  },
  cameraPage: {
    invalidLinkTitle: 'Ogiltig länk',
    invalidLink: {
      default: 'Länken är ogiltig eller har gått ut. Be om en ny länk.',
      expired: 'Länken har gått ut. Be om en ny länk.',
      invalid: 'Länken är ogiltig. Be om en ny länk.'
    },
    grantCamera: 'Du måste ge tillgång till kameran i webbläsarens inställningar.',
    captureFailed: 'Något gick fel. Försök igen.',
    uploadFailed: 'Uppladdningen misslyckades.',
    uploadFailedWithError: 'Uppladdningen misslyckades. {{error}}',
    noPosition: 'Ingen position',
    searchingPosition: 'Söker position…',
    uploadImage: 'Ladda upp bild',
    uploadVideo: 'Ladda upp video',
    imageAlt: 'Bild att ladda upp',
    messagePlaceholder: 'Skriv ett meddelande till ärendet',
    send: 'Ladda upp',
    retake: 'Ta om',
    receiptTitle: 'Tack!',
    receiptPhotoTo: 'Fotot är skickat till {{name}}.',
    receiptPhoto: 'Fotot är skickat.',
    receiptVideoTo: 'Videon är skickad till {{name}}.',
    receiptVideo: 'Videon är skickad.',
    takeAnother: 'Ta ett till'
  },
  locationHelp: {
    deniedTitle: 'Platsen är avstängd för {{browser}}',
    onlyWithLocation: 'Bilder kan bara skickas med plats.',
    inApp: 'Du har öppnat länken inne i {{browser}}. Öppna den i Safari i stället:',
    workPhone: 'Är det en jobbtelefon kan inställningen vara låst. Öppna länken i Safari i stället.',
    retry: 'Försök igen',
    copyLink: 'Kopiera länken',
    openInSafari: 'Öppna i Safari',
    copied: 'Länken är kopierad.',
    copiedPasteInSafari: 'Länken är kopierad. Klistra in den i Safari.',
    searching: 'Söker din position…',
    slow: 'Det tar längre tid än vanligt. Gå gärna utomhus eller närmare ett fönster.',
    continueWithout: 'Fortsätt utan plats',
    confirmWithout:
      'Bilden sparas utan position. Mottagaren ser att platsen saknas. Välj detta bara om platsen inte går att slå på.',
    steps: {
      safariSettings:
        'Öppna <strong>Inställningar</strong> → <strong>Integritet och säkerhet</strong> → <strong>Platstjänster</strong>. Slå på <strong>Platstjänster</strong> och välj <strong>Safari-webbplatser</strong> → <strong>När appen används</strong>.',
      safariSite:
        'Gå tillbaka hit, tryck <strong>aA</strong> i adressfältet → <strong>Webbplatsinställningar</strong> → <strong>Plats</strong> → <strong>Tillåt</strong>.',
      tapRetry: 'Tryck <strong>Försök igen</strong>.',
      inAppOpen:
        'Tryck <strong>Öppna i Safari</strong>, eller <strong>Kopiera länken</strong> och klistra in den i Safari.',
      inAppAllow: 'Tillåt plats när Safari frågar.',
      iosSettings:
        'Öppna <strong>Inställningar</strong> → <strong>Integritet och säkerhet</strong> → <strong>Platstjänster</strong>. Slå på <strong>Platstjänster</strong> och välj <strong>{{browser}}</strong> → <strong>När appen används</strong>.',
      iosRetry:
        'Gå tillbaka hit, tryck <strong>Försök igen</strong> och svara <strong>Tillåt</strong> när {{browser}} frågar.',
      androidLocation: 'Dra ned från skärmens överkant och slå på <strong>Plats</strong>.',
      androidSite:
        'Tryck på ikonen till vänster om adressen → <strong>Behörigheter</strong> → <strong>Plats</strong> → <strong>Tillåt</strong>.',
      otherSite:
        'Tillåt plats för den här sidan i webbläsarens inställningar, ofta via ikonen till vänster om adressen.'
    },
    // The generic browser names detectBrowser gives (detectBrowser.ts#detectBrowser).
    browser: {
      googleApp: 'Google-appen',
      theApp: 'appen',
      theBrowser: 'webbläsaren'
    }
  },
  download: {
    navbar: 'Ladda ner | The Frozen Eye',
    brandAlt: 'Logotyp',
    loading: 'Laddar…',
    errorAlt: 'Fel',
    pdfReport: 'Ladda ner PDF-rapport',
    file: 'Ladda ner fil',
    downloadAs: 'Ladda ner som…',
    png: 'PNG',
    jpeg: 'JPEG',
    pdf: 'PDF',
    video: 'Ladda ner video',
    history: 'Historik',
    unknownUserHidden: 'en kollega (namnet dolt)',
    unknownUserRemoved: 'en borttagen användare',
    assigneeChanged: 'Ansvarig ändrad till <b>{{name}}</b>',
    assigneeChangedUnknown: 'Ansvarig ändrad till <i>{{name}}</i>',
    assigneeRemoved: 'Ansvarig ändrad till <i>ingen</i>',
    statusChanged: 'Status ändrad till <b>{{status}}</b>',
    markedOpen: 'Markerad som öppen',
    markedClosed: 'Markerad som stängd',
    wrote: '<b>{{name}}</b> skrev {{date}} {{time}}',
    wroteUnknown: '<i>{{name}}</i> skrev {{date}} {{time}}'
  }
};
